import { render, staticRenderFns } from "./addInvitation.vue?vue&type=template&id=16fe6f10&scoped=true"
import script from "./addInvitation.vue?vue&type=script&lang=js"
export * from "./addInvitation.vue?vue&type=script&lang=js"
import style0 from "./addInvitation.vue?vue&type=style&index=0&id=16fe6f10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16fe6f10",
  null
  
)

export default component.exports